import { OctagonAlert, TriangleAlert } from 'lucide-react';
import { cn } from '../../lib/cn';
import type { StatusTone } from '../../lib/metrics';

interface MetricValueProps {
  value: string;
  /** Set when a rule on this metric is breaching or firing; adds an icon and a screen-reader label. */
  alert?: { tone: StatusTone; label: string };
}

/** A formatted value that flags itself when it is outside its limit. */
export function MetricValue({ value, alert }: MetricValueProps) {
  const Icon = alert?.tone === 'critical' ? OctagonAlert : alert?.tone === 'warning' ? TriangleAlert : null;
  return (
    <span className="inline-flex items-center gap-[5px]" title={Icon ? alert!.label : undefined}>
      {Icon && (
        <>
          <Icon
            size={13}
            strokeWidth={2.4}
            className={alert!.tone === 'critical' ? 'text-critical' : 'text-warning'}
            aria-hidden
          />
          <span className="sr-only">{alert!.label}: </span>
        </>
      )}
      <span className={cn('font-mono tabular-nums', Icon && 'font-medium')}>{value}</span>
    </span>
  );
}
